import Vue from 'vue'
import LogoLarge from '@/components/LogoLarge.vue'
import LogoSmall from '@/components/LogoSmall.vue'
import LanguageDropdown from '@/components/LanguageDropdown.vue'
import AuthLayoutWrapper from '@/layouts/AuthLayoutWrapper.vue'
import UserMenu from '@/components/UserMenu.vue'
import UserMenuItem from '@/components/UserMenuItem.vue'

Vue.component('LogoLarge', LogoLarge)
Vue.component('LogoSmall', LogoSmall)
Vue.component('LanguageDropdown', LanguageDropdown)
Vue.component('AuthLayoutWrapper', AuthLayoutWrapper)
Vue.component('UserMenu', UserMenu)
Vue.component('UserMenuItem', UserMenuItem)
